module.exports = __webpack_public_path__ + "img/main-hero.dc1da122.gif";